import { PropsWithChildren } from 'react';

import { useProvideUser } from 'hooks/auth/user';

export const UserProvider = ({ children }: PropsWithChildren<{}>) => {
  useProvideUser();
  return <>{children}</>;
};
